import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaEnvelope, FaEnvelopeOpen } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../../Components/PageHeader";
import api from "../../../Utils/api";
import { formatDate } from "../../../Utils/helpers";
import { setLoading } from "../../../store/reducer/loading";
import { deleteMessage, setMessages } from "../../../store/reducer/message";

const Messages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const messages = useSelector((state) => state.message);
  const auth = useSelector((state) => state.auth);
  const messagesNonLus = [...messages].filter(
    (message) => message.readAt === null
  );

  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(messages);
  }, [messages]);

  document.title = `DashBoard | Messages ${
    messagesNonLus.length > 0 ? `(${messagesNonLus.length})` : ""
  }`;

  const columns = [
    {
      name: "Sujet",
      selector: (row) => row.sujet,
      grow: 4,
    },
    {
      name: "Nom",
      selector: (row) => row.nom,
      grow: 2,
    },
    {
      name: "Date",
      selector: (row) => formatDate(row.createdAt, true),
      grow: 2,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <div className="d-flex justify-content-end">
            <Button
              variant={row.readAt ? "outline-success" : "outline-info"}
              className="mr-2"
              onClick={() => navigate(`/message/${row.id}`)}
            >
              {row.readAt ? <FaEnvelopeOpen /> : <FaEnvelope />}
            </Button>
            {auth.roles?.includes("ROLE_ADMIN") && (
              <Button
                variant="outline-danger"
                onClick={() => handleDeleteMessages(row.id)}
              >
                <MdDelete />
              </Button>
            )}
          </div>
        </>
      ),
      grow: 1,
    },
  ];

  const handleDeleteMessages = async (id) => {
    try {
      const response = await api.delete(`message/${id}`);
      if (response.data.Message) {
        dispatch(deleteMessage(id));
        setFilteredData((prev) =>
          [...prev].filter((message) => message.id !== id)
        );
        toast.success("Message supprimé avec succès.");
      }
    } catch (error) {
      toast.error("Vérifier vos données avant la soumission.");
    }
  };

  const handleSearch = () => {
    const result = [...messages].filter(
      (item) =>
        item.sujet.toLowerCase().includes(search.toLowerCase()) ||
        item.nom.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredData(result);
  };

  const tableHearderStyle = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#ccc",
      },
    },
  };

  useEffect(() => {
    const loadMessages = async () => {
      dispatch(setLoading(true));
      try {
        const response = await api.get("message");
        const messages = response.data.messages;

        const messagesTries = messages.sort((a, b) => {
          if (a.readAt === null && b.readAt !== null) return -1;
          if (a.readAt !== null && b.readAt === null) return 1;

          return new Date(b.createdAt) - new Date(a.createdAt);
        });

        console.log(messagesTries);

        dispatch(setMessages(messagesTries));
        setFilteredData(messagesTries);
      } catch (error) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      } finally {
        dispatch(setLoading(false));
      }
    };
    loadMessages();
  }, []);

  return (
    <>
      <PageHeader page="Messages" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="card-tools"></div>
            </div>
            <div className="card-body">
              <DataTable
                customStyles={tableHearderStyle}
                columns={columns}
                data={filteredData}
                pagination
                responsive
                highlightOnHover
                subHeader
                style={{ width: "100%" }}
                // selectableRows
                subHeaderComponent={
                  <input
                    className="form-control w-25"
                    placeholder="Rechercher un message..."
                    type="text"
                    value={search}
                    onChange={({ target }) => setSearch(target.value)}
                    onKeyUp={handleSearch}
                  />
                }
              />
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default Messages;
